import { render, staticRenderFns } from "./wkBase.vue?vue&type=template&id=426d41f6&scoped=true"
import script from "./wkBase.vue?vue&type=script&lang=js"
export * from "./wkBase.vue?vue&type=script&lang=js"
import style0 from "./wkBase.vue?vue&type=style&index=0&id=426d41f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426d41f6",
  null
  
)

export default component.exports